<script setup>
defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const updateValue = (data, event) => {
  data.setValue(event.target.value);
};
</script>

<template>
  <input
    :type="data.type"
    :value="data.value"
    :readonly="data.readonly"
    class="w-full h-8 px-2 text-xs border rounded-md outline-none bg-n-alpha-1 border-n-weak text-n-slate-12 placeholder:text-n-slate-10 focus:border-n-blue-9"
    @input="updateValue(data, $event)"
    @pointerdown.stop
  />
</template>
